(() => {
  const scopeFor = (form) => [...document.querySelectorAll('[data-cart-consent]')]
    .find(scope => scope.querySelector('[data-consent-checkbox]').form === form);
  const validate = (form, event) => {
    const scope = scopeFor(form);
    if (!scope) return;
    const checkbox = scope.querySelector('[data-consent-checkbox]');
    const error = scope.querySelector('[role="alert"]');
    error.hidden = checkbox.checked;
    if (!checkbox.checked) {
      event.preventDefault();
      event.stopImmediatePropagation();
      checkbox.focus();
      checkbox.reportValidity();
    } else {
      scope.querySelector('[data-consent-time]').value = new Date().toISOString();
    }
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('button[name="checkout"], input[name="checkout"]');
    if (button?.form) validate(button.form, event);
  }, true);
  document.addEventListener('submit', event => {
    if (event.target.id === 'cart' || event.target.id === 'CartDrawer-Form') validate(event.target, event);
  }, true);
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-consent-checkbox]')) return;
    const scope = event.target.closest('[data-cart-consent]');
    scope.querySelector('[role="alert"]').hidden = true;
    scope.querySelector('[data-consent-time]').value = event.target.checked ? new Date().toISOString() : '';
  });
})();
